module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img_3.f33ac847.png";